module.exports = __webpack_public_path__ + "media/images/wanderweb/header-wanderweb-mobile-4d7ff3fa306e81e3d109a4ed9142ccd9.jpg";